"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const clsx_1 = __importDefault(require("clsx"));
const react_hook_form_1 = require("react-hook-form");
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const react_datepicker_1 = __importDefault(require("react-datepicker"));
const FieldErrorSectionForm_1 = __importDefault(require("@App/kit/fields/v2/FieldErrorSectionForm"));
const get_input_name_1 = __importDefault(require("@App/forms/v2/helpers/get-input-name"));
const DatePickerForm = (props) => {
    const { control } = (0, react_hook_form_1.useFormContext)();
    const { helperTitle, helperText, label, maxDate = new Date('2100-12-31'), minDate = new Date('1900-01-01') } = props;
    const inputName = (0, get_input_name_1.default)(props);
    return (react_1.default.createElement(react_hook_form_1.Controller, { name: inputName, control: control, render: ({ field: { value, onChange, onBlur, name }, fieldState }) => {
            const classNames = (0, clsx_1.default)('input-text-form-component', 'main-color-set', 'datepicker-form-component', !!value && 'filled', !!fieldState.error && 'error');
            return (react_1.default.createElement("div", { className: classNames, "data-testid": name },
                react_1.default.createElement("label", { htmlFor: name }, label),
                !!helperTitle && !!helperText && react_1.default.createElement(CustomToolTip_1.default, { title: helperTitle, info: helperText }),
                react_1.default.createElement(react_datepicker_1.default, { name: name, onChange: onChange, selected: value, onBlur: onBlur, maxDate: maxDate, minDate: minDate, showPopperArrow: false, dateFormat: 'MMMM d yyyy', peekNextMonth: true, showMonthDropdown: true, showYearDropdown: true, dropdownMode: "select", isClearable: true }),
                react_1.default.createElement(FieldErrorSectionForm_1.default, Object.assign({}, props, { fieldError: fieldState.error }))));
        } }));
};
exports.default = DatePickerForm;
